export type GenerateLiveCodingPathArgs = {
  liveCodingId: number;
  sessionId: string;
  language: string;
};

export const generateLiveCodingPath = (args: GenerateLiveCodingPathArgs) => {
  return `liveCodings/${args.liveCodingId}/sessions/${args.sessionId}/languages/${args.language}`;
};
